import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68810878&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=68810878&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68810878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\01_Projects\\zr_code\\exam_registration_api\\exam-registration-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68810878')) {
      api.createRecord('68810878', component.options)
    } else {
      api.reload('68810878', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68810878&scoped=true", function () {
      api.rerender('68810878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exam-examlist/index.vue"
export default component.exports